module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"InputTodoName":"Input todo name"},"vi":{"InputTodoName":"Nhập công việc..."}}')
  delete Component.options._Ctor
}
